import { useRoute } from 'vue-router';

import { useCart } from '@/modules/shop/composables/useCart';

const useEventsTicketsAddMembers = () => {
	// Init
	const route = useRoute();
	const { getCartItem, updateCartAdditionalInfoByIndex } = useCart();
	const cartItemIndex = route.query.cartItemIndex?.toString();

	// updateTicketData
	const updateTicketData = () => {
		// If user is not participant of ticket and there is no cartItemIndex
		// User already participant or cartItemIndex is sent
		const name = route.query.friendFullName?.toString();
		const email = route.query.friendEmail?.toString();
		const user_id = route.query.friendId?.toString();

		// Update cart item
		if (name && email && user_id && cartItemIndex) {
			const cartItem = getCartItem(+cartItemIndex);
			updateCartAdditionalInfoByIndex(+cartItemIndex, {
				...cartItem?.additionalInfo,
				email,
				name,
				user_id,
			});
		}
	};

	return {
		updateTicketData,
	};
};

export default useEventsTicketsAddMembers;
